import * as React from 'react';
import { SVGProps } from 'react';

const IconPasteSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 .5a1 1 0 0 0-1 1H4V3h4V1.5H7a1 1 0 0 0-1-1z" />
    <path d="M3 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1v8.999H3V2z" />
    <path d="M8 6v1H4V6h4zM7 8H4v1h3V8z" />
  </svg>
);
export default IconPasteSizeXs;
